import View from './View';

export default class KeyboardAvoid extends View {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }
}
